export default {
  state: {
    count: 0,
  },
  increase(value = 1) {
    this.state.count += value;
  },
  decrease(value = 1) {
    this.state.count -= value;
  },
};
